import AbstractPopup from "./AbstractPopup";
import Button from "../../views/components/Button";
import ViewManager from "../../utils/ViewManager";
import { DefaultLayers } from "../../utils/Layers";
import PointerEvents from "../../const/PointerEvents";
import TextField from "../../views/components/TextField";
import Locale, { LocaleId } from "../../utils/Locale";
import errorModel from "../../model/ErrorModel";
import App from "../../App";
import SoundController from '../../utils/SoundController';
import SoundVars from '../../const/SoundVars';
import ErrorModel from "../../model/ErrorModel";
import Utils from "../../utils/Utils";
import BetModel from "../../model/BetModel";
import BuyFeatureModel from "../../model/BuyFeatureModel";

export default class ErrorPopup extends AbstractPopup {
    public title: TextField;
    public text: TextField;
    public closeBtn: Button;

    constructor() {
        super();
        this.layer = ViewManager.getLayer(DefaultLayers.Popups);
    }

    public show(callback?: Function, forcedText?: string) {
        super.show();
        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
        const errorTranslationKey = 'error.' + errorModel.errorCode;
        let text = forcedText || Locale.getString(errorTranslationKey);
        // if (!App.assets.loaded) {
        //     this.hide();
        //     alert("Error: " + (forcedText || Locale.getString(errorModel.errorMessage + "\nErrorCode: " + errorModel.errorCode)));
        //     return;
        // }

        if (!Locale.isTranslated(text, errorTranslationKey)) {
            // No translation for this error
            text = !Utils.isNullOrWhiteSpace(ErrorModel.errorMessage) ? ErrorModel.errorMessage : text;
        }

        this.scene = this.layer.setScene("error");
        this.scene.interactive = true;
        this.closeBtn = this.scene.buttons.get("close");
        this.closeBtn = this.scene.buttons.get("close");
        if (!this.closeBtn) {
            this.closeBtn = this.scene.buttons.get("exit");
        }
        this.text = this.scene.sceneTextFields.get("text") as TextField;
        this.text.text = text;
        this.title = this.scene.sceneTextFields.get("title") as TextField;
        this.title.text = Locale.getString(LocaleId.gui_lbl_error);

        this.closeBtn.once(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            if (callback) {
                callback();
            }

            ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
            this.hide();
        });
    }

    public setText(value: string) {
        this.text.text = value;
    }

    public setTitle(value: string) {
        this.title.text = value;
    }

    public hide(): void {
        super.hide();
        if (ErrorModel.errorCode === 506 && BuyFeatureModel.hasBuyFeatureIsTriggered || BuyFeatureModel.isInBuyFeatureFreeSpins) {
            BetModel.totalBet = BetModel.coinSize;
            BuyFeatureModel.hasBuyFeatureIsTriggered = false;
            BuyFeatureModel.isInBuyFeatureFreeSpins = false;
        }
        errorModel.errorCode = -1;
    }

    protected hideFromKeyboard() { }
}
